import React from 'react';
import { gameStateManager } from '../../App';
import { utils } from '../../utils';
import BoardSprite from "./BoardSprite"
import { useEffect, useState } from "react";
import PixiAnimatedContainer, { EASING } from './PixiAnimatedContainer';
import { boardTileSize } from '../../env';

const BoardMeeple = ( { textureCache, ...props } ) =>
{
  return (
    <BoardSprite
      anchor={ { x: 0.5, y: 0.75 } }
      textureCache={ textureCache }
      { ...props }
    />
  );
};

const PixiReturningMeepleAnimationHandler = ( { textureCache, endGamePhaseAnimDelay } ) =>
{
  const [ returningMeepleDatas, setReturningMeepleDatas ] = useState( [] );
  const [ renderScale, setRenderScale ] = useState( 1.0 );

  const SCORING_MEEPLE_ANIM_STEPS = [
    {
      fromOffsetX: 0,
      fromOffsetY: 0,
      toOffsetX: 0,
      toOffsetY: -50,
      duration: 300,  // ms
      easing: EASING.OUT_CUBIC
    },
    {
      fromOffsetX: 0,
      fromOffsetY: -50,
      toOffsetX: 0,
      toOffsetY: 0,
      duration: 300,  // ms
      easing: EASING.IN_CUBIC,
      loopFromIndex: 0,
      loopIterations: 3
    },
    {
      fromOffsetX: 0,
      fromOffsetY: 0,
      fromAlpha: 1,
      toOffsetX: 0,
      toOffsetY: 0,
      toAlpha: 0,
      duration: 500,  // ms
      easing: EASING.IN_OUT_BOUNCE,
    },
  ];

  const NON_SCORING_MEEPLE_ANIM_STEPS = [
    {
      fromOffsetX: 0,
      fromOffsetY: 0,
      toOffsetX: 0,
      toOffsetY: -20,
      duration: 600,  // ms
      easing: EASING.OUT_CUBIC
    },
    {
      fromOffsetX: 0,
      fromOffsetY: -20,
      toOffsetX: 0,
      toOffsetY: 0,
      duration: 600,  // ms
      easing: EASING.IN_CUBIC,
      loopFromIndex: 0,
      loopIterations: 1
    },
    {
      fromOffsetX: 0,
      fromOffsetY: 0,
      fromAlpha: 1,
      toOffsetX: 0,
      toOffsetY: 0,
      toAlpha: 0,
      duration: 500,  // ms
      easing: EASING.IN_OUT_BOUNCE,
    },
  ];

  useEffect( () =>
  {
    let onMeepleReturnAnimationRequest = ( data ) =>
    {
      // console.log( 'PixiReturningMeepleAnimationHandler - onMeepleReturnAnimationRequest() data', data );

      // meepleDatas:[
      //  { isFarmer: false,
      //    localMeepleCoords: {x: 0, y: 0.32},
      //    tileHash: "130304"
      //  }
      // ]
      // playerColourHex: "#2b6fc1"
      // playerColourID: "blue"
      // pointsScored: 4

      if( data.meepleDatas )
      {
        for( let idx = 0; idx < data.meepleDatas.length; idx++ )
        {
          let meepleData = data.meepleDatas[ idx ];
          let tileCoord = utils.hashToCoord( meepleData.tileHash );
          const newReturningMeepleData =
          {
            isFarmer: meepleData.isFarmer,
            localMeepleCoords: meepleData.localMeepleCoords,
            tileCoords: tileCoord,
            playerColourHex: data.playerColourHex,
            playerColourID: data.playerColourID,
            didScorePoints: data.pointsScored > 0
          };

          // console.log( `Adding newReturningMeepleData: `, newReturningMeepleData );

          setReturningMeepleDatas( prev => [ ...prev, newReturningMeepleData ] );
        }
      }
    };

    let onStageRenderDataChanged = ( stageRenderData ) =>
    {
      setRenderScale( stageRenderData.scale );
    };

    gameStateManager.addOnMeepleReturnAnimationRequestCallback( onMeepleReturnAnimationRequest );

    let currentStageRenderData = gameStateManager.addOnStageRenderDataChangeCallback( onStageRenderDataChanged );
    setRenderScale( currentStageRenderData.scale );

    return () =>
    {
      gameStateManager.removeOnMeepleReturnAnimationRequestCallback( onMeepleReturnAnimationRequest );
      gameStateManager.removeOnStageRenderDataChangeCallback( onStageRenderDataChanged );
    };
  }, [] ); // Empty dependency array means "run once"


  // console.log( "RENDER RETURNING MEEPS ANIMS delay : ", ( gameStateManager.isInEndGamePhaseState() ? endGamePhaseAnimDelay : 0 ) );

  let meepleElements = [];

  for( let idx = 0; idx < returningMeepleDatas.length; idx++ )
  {
    let meepleData = returningMeepleDatas[ idx ];
    let tileCoords = meepleData.tileCoords;
    let localMeepleCoords = meepleData.localMeepleCoords;

    meepleElements.push(
      <PixiAnimatedContainer
        key={ `returningBoardMeeple_${tileCoords.x}_${tileCoords.y}` }
        x={ ( tileCoords.x + localMeepleCoords.x ) * boardTileSize }
        y={ ( -1 * ( tileCoords.y + localMeepleCoords.y ) ) * boardTileSize }
        delay={ gameStateManager.isInEndGamePhaseState() ? endGamePhaseAnimDelay : 0 }
        renderScale={ renderScale }
        animSteps={
          meepleData.didScorePoints ? SCORING_MEEPLE_ANIM_STEPS : NON_SCORING_MEEPLE_ANIM_STEPS
        }
        onAnimFinish={ () =>
        {
          // Remove this entry from the state array to stop it re-rendering
          setReturningMeepleDatas( prev => prev.filter( mData => mData !== meepleData ) );
        } }
      >
        <BoardMeeple
          textureCache={ textureCache }
          imageSrc={ utils.getAssetPath(`./meeples/Meeple - ${meepleData.isFarmer ? 'Farmer' : 'Standard'} - ${meepleData.playerColourID}.png`) }
          renderScale={ renderScale }
          x={ 0 }
          y={ 0 }
        />

      </PixiAnimatedContainer>
    );
  }

  return (
    <>
      { meepleElements }
    </>
  );
}

export default React.memo( PixiReturningMeepleAnimationHandler,
  ( prevProps, nextProps ) =>
  {
    // NOTE: We never want this component to be re-rendered because the parent component is re-rendering.
    return true;
  }
);
